import { InfoField } from '@occc/ui-design-system';
import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { formatYesNoValues } from '../../formatters';

export const VoucherStackingConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const cst = getConstraintsByType('ConstraintRequiresTransactionVoucher', constraints);
  const values = cst.map((v) => v.allowSingleOfferVoucherStacking);

  return <InfoField label='Voucher Stacking' value={formatYesNoValues(values)} />;
};
